import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import './mode-selection.component.scss';
import { namespace } from 'vuex-class';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { TaskTypeSorting } from '@/tsort/enum/task-type-sorting.enum';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import RouterUtils from '@/common/utils/router.util';
import AppConstants from '@/common/constants/app.constants';

const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
@Component({})
export default class TaskTypeModalComponent extends Vue {
  // Props mode selection
  @Prop() listTaskTypeSorting!: Array<ScanSystemMenuResponse>;
  @Prop() showButtonBackModal!: boolean;

  // Define variavble
  uniqueTaskTypes: Array<number> = [];

  // Start store
  @SortStore.Action
  updateTaskTypeSorting!: (value: TaskTypeSorting | string) => void;
  // End store

  /**
   * 監視変更リスト タスク タイプ 並べ替え
   */
  @Watch('listTaskTypeSorting')
  async listTaskTypeSortingChange() {
    this.filterTaskTypeUnique();

    // Check lenght task type
    if (this.uniqueTaskTypes.length === 1) {
      this.handleModalTaskTypeSorting(this.listTaskTypeSorting[0].taskType);
    } else {
      this.$bvModal.show('idTaskTypeModal');
    }
  }

  /**
   * モーダルを閉じる。
   */
  private closeModal(): void {
    this.$bvModal.hide('idTaskTypeModal');
    RouterUtils.goToRouterName(AppConstants.NAME_TOP_PAGE);
  }

  /**
   * 作業タイプモーダルに戻る。
   */
  @Emit('backWorkTypeModal')
  backWorkTypeModal() {
    this.$bvModal.hide('idTaskTypeModal');
  }

  /**
   * イベントを公開する タスクの種類を選択する
   *
   * @param taskType  タスクの種類
   */
  @Emit('taskTypeSelected')
  handleModalTaskTypeSorting(taskType: TaskTypeSorting) {
    // Update store when choose task type mode
    this.updateTaskTypeSorting(taskType);
    this.$bvModal.hide('idTaskTypeModal');
  }

  /**
   * タスクの種類を一意にフィルターする。
   */
  private filterTaskTypeUnique(): void {
    const uniqueWorkType = [...new Set(this.listTaskTypeSorting.map((item) => item.taskType))];
    this.uniqueTaskTypes = uniqueWorkType.sort((a, b) => b - a);
  }

  render() {
    return (
      <b-modal
        id="idTaskTypeModal"
        centered
        no-close-on-backdrop={true}
        hide-footer
        body-class="align-modal-bottom"
        size="lg"
        hide-header
      >
        <template class="modal-header border-bottom-0 d-flex flex-column align-items-center justify-content-center">
          {this.showButtonBackModal && (
            <a
              type="button"
              onClick={() => {
                this.backWorkTypeModal();
              }}
              class="font-weight-bold text-secondary arrow-back  arrow-back__task-type text-decoration-none"
            >
              <span class="icon icon-arrow-back-svg"></span>
            </a>
          )}
          <span
            class="icon icon-close-modal-svg text-font text-font__task-type cursor-pointer"
            onClick={() => {
              this.closeModal();
            }}
          ></span>
          <h3 class="font-weight-bold">仕分け方法を選択してください</h3>
          <span class="text-size mb-2 mt-1">3/3</span>
        </template>
        <div class="row d-flex flex-row justify-content-center align-row-sorting">
          {this.listTaskTypeSorting?.map((item) => {
            return (
              <div
                class="col py-4 border-top btn-sorting"
                onClick={() => {
                  this.handleModalTaskTypeSorting(item.taskType);
                }}
              >
                <strong class="font-weight-bold h4 ml-2 text-break">{item.taskTypeName}</strong>
              </div>
            );
          })}
        </div>
      </b-modal>
    );
  }
}
